export const blockIconsPlacesFamilyRestroom = (
	<span className='material-symbols-outlined'>family_restroom</span>
);
